<app-split-pane
  storageKey="split.stats"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.stats.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat [suggestions]="statsSuggestions" [context]="statsContext" placeholder="Ask about stats and trends..."></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="stats.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.stats.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="page-workspace">
          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h2 class="h4 mb-1">Stats</h2>
            <p class="text-muted mb-3">Generate delivery metrics reviews and trend snapshots for project tracking.</p>
            <h3 class="h5 mb-3">Stats Review Inputs</h3>
            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Time range</label>
                <select class="form-select" [(ngModel)]="statsDraft.timeRange">
                  <option value="">Select range...</option>
                  @for (option of timeRangeOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-md-4">
                <label class="form-label">Metric focus</label>
                <input class="form-control" [(ngModel)]="statsDraft.metricFocus" placeholder="e.g. Delivery velocity" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Comparison group (optional)</label>
                <input class="form-control" [(ngModel)]="statsDraft.comparisonGroup" placeholder="e.g. Previous sprint" />
              </div>
            </div>
            <div class="mt-3">
              <button class="btn btn-primary" type="button" [disabled]="generatingStats" (click)="generateStatsReview()">
                @if (generatingStats) {
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Generating...
                } @else {
                  Generate Stats Review
                }
              </button>
            </div>
            @if (statsError) {
              <div class="alert alert-danger mt-3 mb-0">{{ statsError }}</div>
            }
            @if (statsSuccess) {
              <div class="alert alert-success mt-3 mb-0">{{ statsSuccess }}</div>
            }
          </section>

          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h3 class="h5 mb-3">Trend Summary</h3>
            @if (!hasGeneratedStats) {
              <div class="small text-muted">No review generated yet. Generate stats review to populate summary.</div>
            } @else {
              <div class="summary-grid">
                <article class="summary-card">
                  <div class="summary-label">Time range</div>
                  <div class="summary-value">{{ statsDraft.timeRange }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Metric focus</div>
                  <div class="summary-value">{{ statsDraft.metricFocus }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Comparison</div>
                  <div class="summary-value">{{ statsDraft.comparisonGroup.trim() || 'No comparison set.' }}</div>
                </article>
              </div>
            }
          </section>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="stats.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
